<template>
  <el-dialog
    :title="dialogInfo.title"
    :visible.sync="dialogInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <el-input
      v-if="dialogInfo.isEdit"
      type="textarea"
      :rows="5"
      maxlength="500"
      show-word-limit
      v-model="remark"
      placeholder="请输入班级备注"
    />
    <div v-else class="line-30">
      {{ dialogInfo.remark }}
    </div>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" v-if="dialogInfo.isEdit" title="取消" />
      <butn btntype="primary" @click="sureEdit" title="确认" />
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { updateRemarks } from "@/api/studyService/index.js";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      remark: "",
    };
  },
  created() {
    this.remark = this.dialogInfo.remark;
  },
  methods: {
    sureEdit() {
      if (!this.dialogInfo.isEdit) {
        this.closeDialog(false);
        return;
      }
      // if (!this.remark) {
      //   this.$message.warning("请输入班级备注!");
      //   return;
      // }
      updateRemarks({ remarks: this.remark, uuid: this.dialogInfo.uuid }).then(
        ({ code, msg }) => {
          if (code !== 0) return;
          this.$message.success(msg);
          this.closeDialog(true);
        }
      );
    },
    closeDialog(flag = false) {
      this.$emit("close", flag);
    },
  },
};
</script>

<style lang="scss" scoped>
.line-30 {
  line-height: 30px;
}
</style>
